import clsx from 'clsx';
import React from 'react';
import { Nav } from 'react-bootstrap';

import './BayTabs.scss';

import TabTitle from './components/TabTitle';

interface TabItem {
	title?: string;
	eventKey?: string;
	count?: number;
	icon?: React.ReactElement | string;
	withBadge?: boolean;
	func?: () => void;
}

interface BayTabsProps {
	tabArray?: TabItem[];
	bold?: boolean;
	activeKey?: string;
	id?: string;
	className?: string;
	children?: React.ReactNode;
	childrenAdditional?: React.ReactNode;
	hideTooltip?: boolean;
}

const BayTabs: React.FC<BayTabsProps> = ({
	tabArray,
	bold,
	activeKey,
	id,
	className,
	children,
	childrenAdditional,
	hideTooltip,
}) => (
	<Nav
		className={clsx(['bay-tabs ', className])}
		activeKey={activeKey}
		id={id ? `bay_tabs_${id}` : ''}
		style={{ width: 'fit-content' }}
		variant={bold ? 'tabs' : 'none'}
	>
		{!children
			? tabArray?.map((item, index) => (
				<Nav.Item
					key={index}
					className={`${bold ? 'tab-bold' : 'tab-underline'} text-nowrap`}
					onClick={item.func ? item.func : () => void 0}
				>
					<Nav.Link
						eventKey={
							item.eventKey ? item.eventKey : item.title ? item.title : index
						}
					>
						<TabTitle
							count={item.count}
							hideTooltip={hideTooltip}
							icon={item.icon}
							titleText={item.title}
							withBadge={item.withBadge}
						/>
					</Nav.Link>
				</Nav.Item>
			))
			: children}
		{childrenAdditional}
	</Nav>
);

export default BayTabs;
